// @core/api/endpoints/payment/void_payment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  VoidPaymentRequest,
  VoidPaymentResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Void authorized payment
 * Voids a payment authorization, releasing the held funds.
 */
export async function VoidPayment(
  id: string,
  data: VoidPaymentRequest,
  options?: RequestOptions
): Promise<VoidPaymentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payments/:id/void`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.post<VoidPaymentResponse>(requestPath, data, requestOptions);
}
